/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef, useState } from "react";

import WaveSurfer from "wavesurfer.js";

import { Icon, PlainButton } from "@culturehq/components";
import { Audio } from "chq";

interface WaveformProps {
  audio: Audio;
  audioWidth?: number;
  isPlaying: boolean;
  onPlay: () => void;
  onClose?: () => void;
  preview: boolean;
}

const Waveform: React.FC<WaveformProps> = ({
  audio, isPlaying, audioWidth, onClose, onPlay, preview
}) => {
  const waveformRef = useRef<HTMLDivElement>(null);
  const wavesurfer = useRef<WaveSurfer | null>(null);

  useEffect(
    () => {
      if (audio?.url && waveformRef.current) {
        wavesurfer.current = WaveSurfer.create({
          barWidth: 1,
          cursorWidth: 1,
          container: waveformRef.current,
          backend: "WebAudio",
          height: preview ? 10 : 20,
          progressColor: "#8cb4d6",
          responsive: true,
          waveColor: "#FFFFFF",
          cursorColor: "transparent"
        });

        wavesurfer.current.load(audio.url);

        wavesurfer.current.on("ready", () => {});
      }

      return () => wavesurfer.current?.destroy();
    }, [audio, preview]
  );

  useEffect(() => {
    if (wavesurfer.current) {
      if (isPlaying) {
        wavesurfer.current.play();
      } else {
        wavesurfer.current.pause();
      }
    }
  }, [isPlaying]);

  const handlePlay = () => {
    onPlay();
    if (wavesurfer.current) {
      wavesurfer.current.playPause();
    }
  };

  const handleClose = () => {
    if (onClose) onClose();
  };

  if (!audio?.url) {
    return <></>;
  }

  return (
    <div className="WaveformContainer" style={{ width: `${audioWidth}px` }}>
      <PlainButton className="PlayButton" onClick={handlePlay}>
        {isPlaying ? (
          <Icon className="Audio--Icon" icon="pause" />
        ) : (
          <Icon className="Audio--Icon" icon="play-no-border" />
        )}
      </PlainButton>
      <div className="Wave" ref={waveformRef} />
      <audio src={audio.url} />
      {onClose && <Icon className="close-icon" icon="close" onClick={handleClose} />}
    </div>
  );
};

export default Waveform;
